<template>
  <section class="background">
    <div class="conteudo tela-login">
      <h2 class="title">SSP Módulo Financeiro</h2>
      <b-form v-if="show" class="login">
        <b-form-group id="input-group-1" label="Digite seu endereço de e-mail:" label-for="input-1" description="">
          <b-form-input id="input-1" v-model="form.email" type="email" required placeholder="Digite aqui seu e-mail"></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-1" label="Senha:" label-for="input-2" description="">
          <b-form-input id="input-2" v-model="form.password" type="password" required placeholder="Digite sua senha"></b-form-input>
        </b-form-group>
        <div class="ms-cadastro">
          <!-- <div>
                  <p><a :href="`${env.CADASTRO_USUARIO}/registrar`">Não tem cadastro? Clique aqui.</a></p>
                </div> -->
          <div>
            <p><a :href="`${env.CADASTRO_USUARIO}/reset`">Esqueci a senha.</a></p>
          </div>
        </div>
        <div>
          <b-button type="button" variant="primary" v-on:click="onSubmit()">Entrar</b-button>
        </div>
      </b-form>
    </div>
    <div class="indentificacao-ambiente">
      <small>{{ env.NODE_ENV }} v1</small>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      show: true,
      env: process.env,
      sessaoUsuario: this.$store.state.login.loginUsuario.token,
      gruposPermitidos: ['oi', 'admin', 'adminVTAL']
    }
  },
  mounted: function () {
    if (localStorage.getItem('sessaoUsuario')) {
      let sessaoUsuario = JSON.parse(localStorage.getItem('sessaoUsuario'))
      this.$store.commit('setLoginUsuario', sessaoUsuario)
    }

    if (!this.$store.state.login.loginUsuario.token) {
      let vm = this
      window.addEventListener('keyup', function (key) {
        if (key.code === 'NumpadEnter' || key.code === 'Enter') {
          console.log(key.code)
          vm.onSubmit()
        }
      })
    }
  },
  methods: {
    onSubmit() {
      localStorage.clear()
      this.solicitaToken()
    },
    solicitaToken: function () {
      let vm = this
      this.$axios.post(`${this.env.AUTENTICA}/solicitatoken`, this.form)
        .then(function (response) {
          if (!response.data.token) {
            vm.$store.commit('setAlert', { msg: 'Usuário ou senha estão incorretos', status: false, show: true })
            return
          }
          if (response.data.grupo.find(permissao => permissao.nome === 'oi' || permissao.nome === 'admin' || permissao.nome === 'adminVTAL')) {
            localStorage.setItem('sessaoUsuario', JSON.stringify(response.data))
            window.location.href = vm.$route.fullPath
            // if (vm.gruposPermitidos.indexOf(response.data.grupo.nome) === -1) {
            //   window.location.href = '/'
            // } else {
            window.location.href = '/listarSla'
            // }
          } else {
            let sessaoUsuario = []
            vm.$store.commit('setLoginUsuario', sessaoUsuario)
            localStorage.clear()
            vm.$store.commit('setAlert', { msg: 'Seu perfil não permite acesso a esta plataforma.', status: false, show: true })
            return
            // setTimeout(() => {
            //   window.location.href = '/'
            // }, 3000)
          }
        }).catch(function (error) {
          console.log(error)
          vm.$store.commit('setAlert', { msg: `Falha temporária. Tente novamente mais tarde!`, status: false, show: true })
          localStorage.clear()
          if (error.response.data.mensagem || error.response.data.message) {
            if (error.response.status === 410) {
              vm.$store.commit('setAlert', { msg: error.response.data.mensagem, status: false, show: true })
              setTimeout(() => { window.location.href = `${vm.env.CADASTRO_USUARIO}` }, 3000)
            } else if (error.response.status === 401) {
              vm.$store.commit('setAlert', { msg: error.response.data.mensagem, status: false, show: true })
              return
            } else {
              vm.$store.commit('setAlert', { msg: error.response.data.mensagem, status: false, show: true })
              return
            }
          }
        })
    },
    encriptBase64: function (string) {
      let varB64 = btoa(string)
      return varB64
    },
    decriptBase64: function (string) {
      let varB64
      try {
        varB64 = atob(string)
      } catch (e) {
        localStorage.clear()
      }
      return varB64
    }
  }
}
</script>



<style scoped>
.ms-cadastro {
  display: flex;
  justify-content: space-between;
  margin-left: 0.1em;
}

.tela-login {
  max-width: 40em;
  margin: auto;
  margin-top: 10%;
}

.login {
  box-shadow: 15px 15px 15px black;
}

small {
  font-size: .7em;
  visibility: hidden;
}

.indentificacao-ambiente {
  bottom: 0;
  right: 0;
  color: #ccc;
}

.background {
  background-image: url('../../assets/background-imagem-tela-login.jpg');
  background-repeat: no-repeat;
  background-position: center;
  position: fixed;
  padding: 0;
  width: 100%;
  height: 100vh;
}

.login {
  border: 1px solid rgb(161, 161, 161);
  border-radius: 9px;
  padding: 5%;
  background-color: rgba(218, 218, 218, 0.548);
}

.title {
  text-align: center;
  color: #000000;
  margin: 2em 0 1em 0;
}
</style>



// WEBPACK FOOTER //
// Login.vue?52f00738